var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Injectable } from '@angular/core';
var ConfigureRouteGuard = /** @class */ (function () {
    function ConfigureRouteGuard(permissionChecker, router, sessionService) {
        this.permissionChecker = permissionChecker;
        this.router = router;
        this.sessionService = sessionService;
    }
    ConfigureRouteGuard.prototype.canActivate = function (route, state) {
        if (!this.sessionService.user) {
            this.router.navigate(['/account/login']);
            return false;
        }
        if (!route.data || !route.data['permission']) {
            return true;
        }
        if (this.permissionChecker.isGranted(route.data['permission'])) {
            return true;
        }
        this.router.navigate([this.selectBestRoute()]);
        return false;
    };
    ConfigureRouteGuard.prototype.canActivateChild = function (route, state) {
        return this.canActivate(route, state);
    };
    ConfigureRouteGuard.prototype.selectBestRoute = function () {
        if (!this.sessionService.user) {
            return '/account/login';
        }
        return '/app/notifications';
    };
    ConfigureRouteGuard = __decorate([
        Injectable()
    ], ConfigureRouteGuard);
    return ConfigureRouteGuard;
}());
export { ConfigureRouteGuard };
